module.exports = require("promise-worker");